<form>
  <div class="modal-header">
    <h5 class="modal-title d-flex align-items-center">
      <i class="ri-draft-line me-1 font-20 text-primary"></i> Employee Course Test
    </h5>
    <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
      (click)="activeModal.close('Close')"></button>
  </div>
</form>
<div class="course-details-container p-4">
  <div class="row">
    <div class="col-md-4 mb-3">
      <div class="course-card bg-white p-3 rounded shadow-sm h-100">
        <div class="d-flex flex-column">
          <span class="text-muted mb-2">Course Name</span>
          <span class="fw-medium text-capitalize">{{ course.employeeName || 'N/A' }}</span>
        </div>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <div class="course-card bg-white p-3 rounded shadow-sm h-100">
        <div class="d-flex flex-column">
          <span class="text-muted mb-2">Course Code</span>
          <span class="fw-medium">{{ course.employeeCode || 'N/A' }}</span>
        </div>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <div class="course-card bg-white p-3 rounded shadow-sm h-100">
        <div class="d-flex flex-column">
          <span class="text-muted mb-2">Duration (In days)</span>
          <span class="fw-medium">{{ course.duration || 0 }}</span>
        </div>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <div class="course-card bg-white p-3 rounded shadow-sm h-100">
        <div class="d-flex flex-column">
          <span class="text-muted mb-2">Maximum Retries</span>
          <span class="fw-medium">{{ course.maxRetries || 0 }}</span>
        </div>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <div class="course-card bg-white p-3 rounded shadow-sm h-100">
        <div class="d-flex flex-column">
          <span class="text-muted mb-2">Retry Days</span>
          <span class="fw-medium">{{ course.retryDays || 0 }}</span>
        </div>
      </div>
    </div>
    <div class="col-md-4 mb-3">
      <div class="course-card bg-white p-3 rounded shadow-sm h-100">
        <div class="d-flex flex-column">
          <span class="text-muted mb-2">Remaining Days</span>
          <span class="fw-medium">{{ course.remainingDays || 0 }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container p-0">
  <div class="main-body">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <div *ngIf="slides.length > 0; else noSlides" id="carouselExampleIndicators" class="carousel slide"
              data-bs-interval="false" (slide.bs.carousel)="onSlide($event)">
              
              <ol class="carousel-indicators">
                <li *ngFor="let slide of slides; let i = index"
                    data-bs-target="#carouselExampleIndicators"
                    [attr.data-bs-slide-to]="i"
                    [class.active]="i === 0"></li>
              </ol>

              <div class="carousel-inner">
                <div *ngFor="let slide of slides; let i = index"
                     class="carousel-item"
                     [class.active]="i === 0">
                  <div class="card h-100">
                    <div class="row g-0 align-items-stretch min-h-400">
                      <div class="col-md-6">
                        <div class="media-container">
                          <img *ngIf="slide.mediaUrl && slide.mediaUrl.trim() !== '' && !slide.mediaUrl.endsWith('.mp4')"
                            [src]="slide.mediaUrl"
                            class="media-content img-fluid rounded shadow-sm"
                            alt="Slide Image" />

                          <video *ngIf="slide.mediaUrl && slide.mediaUrl.endsWith('.mp4')"
                            controls
                            class="media-content img-fluid rounded shadow-sm">
                            <source [src]="slide.mediaUrl" type="video/mp4" />
                          </video>

                          <img *ngIf="!slide.mediaUrl || slide.mediaUrl.trim() === ''"
                            src="assets/images/no_media.png"
                            class="media-content img-fluid rounded shadow-sm"
                            alt="No Media Available" />
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="card-body slide-content-body">
                          <h5 class="card-title text-primary capitalize-first-letter fixed-title">
                            {{ slide.title || 'No Title' }}
                          </h5>
                          <div class="scrollable-content">
                            <p class="card-text text-colour">
                              {{ slide.content || 'No Content Available' }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <a class="carousel-control-prev custom-carousel-btn"
                 href="#carouselExampleIndicators"
                 role="button"
                 data-bs-slide="prev"
                 *ngIf="currentSlideIndex > 0">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
              </a>

              <a class="carousel-control-next custom-carousel-btn"
                 href="#carouselExampleIndicators"
                 role="button"
                 data-bs-slide="next"
                 *ngIf="currentSlideIndex < slides.length - 1">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
              </a>

              <div *ngIf="slides.length > 0" class="text-center mt-3">
                <span class="fw-bold">{{ currentSlideIndex + 1 }}/{{ slides.length }}</span>
              </div>

              <div *ngIf="slides.length > 0 && currentSlideIndex === slides.length - 1"
                   class="d-flex justify-content-end mt-3">
                <button class="btn btn-secondary" (click)="confirmCloseModal(course)">Done</button>
              </div>
            </div>

            <ng-template #noSlides>
              <p class="text-center text-muted">No slides available</p>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

